import { render, staticRenderFns } from "./MenuBlackstory.vue?vue&type=template&id=6f51df96&scoped=true&"
import script from "./MenuBlackstory.vue?vue&type=script&lang=js&"
export * from "./MenuBlackstory.vue?vue&type=script&lang=js&"
import style0 from "./MenuBlackstory.vue?vue&type=style&index=0&id=6f51df96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f51df96",
  null
  
)

export default component.exports